"use strict";
export var AccountType = /* @__PURE__ */ ((AccountType2) => {
  AccountType2["SignerMnemonic"] = "signerMnemonic";
  AccountType2["Readonly"] = "readonly";
  return AccountType2;
})(AccountType || {});
export var DisplayNameType = /* @__PURE__ */ ((DisplayNameType2) => {
  DisplayNameType2[DisplayNameType2["Address"] = 0] = "Address";
  DisplayNameType2[DisplayNameType2["ENS"] = 1] = "ENS";
  DisplayNameType2[DisplayNameType2["Local"] = 2] = "Local";
  DisplayNameType2[DisplayNameType2["Unitag"] = 3] = "Unitag";
  return DisplayNameType2;
})(DisplayNameType || {});
